export enum DetailTypes {
  CREATOR = 'CREATOR',
  ADDRESS = 'ADDRESS',
  DATE = 'DATE',
  CATEGORY = 'CATEGORY',
  CONTACT = 'CONTACT',
  LOCATION = 'LOCATION',
}
